import Dialog from 'components/Common/Modals/Dialog'
import Icon from 'components/Pages/BuyWine/RequestCreate/Check/Modal/Attention/Icon'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { ButtonContent, Button } from 'components/Common/MasterComponents'
import { FC } from 'react'

const Content = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  --gap: 24px;
  text-align: center;
  padding: var(--gap);
`
const Title = styled.div`
  font: var(--typography-18-24-semibold);
  margin-top: 16px;
`
const Sub = styled.div`
  font: var(--typography-14-20-regular);
  color: var(--color-sns-80);
`
const Footer = styled.div`
  margin-top: var(--gap);
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`

interface IProps {
  onClose: () => void
  loading: boolean
  onUpdate: () => void
}

const ConfirmDialog: FC<IProps> = ({ onClose, loading, onUpdate }) => {
  const { t } = useTranslation()

  return (
    <Dialog.Wrapper onClose={onClose}>
      <Dialog.Main width={328}>
        <Dialog.Content>
          <Content>
            <Icon color={'var(--color-orange)'} />
            <Title>
              {t('capturedWines.dialog.updateImages.updateQuestion')}
            </Title>
            <Sub>{t('capturedWines.dialog.updateImages.updateDesc')}</Sub>
            <Footer>
              <Button $type='primary' $size='L' onClick={onUpdate}>
                <ButtonContent loading={loading}>
                  {t('capturedWines.dialog.updateImages.update')}
                </ButtonContent>
              </Button>
              <Button
                $type='secondary'
                $size='L'
                disabled={loading}
                onClick={onClose}
              >
                {t('common.cancel')}
              </Button>
            </Footer>
          </Content>
        </Dialog.Content>
      </Dialog.Main>
    </Dialog.Wrapper>
  )
}

export default ConfirmDialog
